import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Fear",
    opening: localizedGenderNode(
      [
      "Today I do not fight the fear.",
      "I only notice: it is here."
    ],
      [
      "Today I do not fight the fear.",
      "I only notice: it is here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is this fear the strongest?",
      "What picture comes up about old age?",
      "What do I feel in my body?"
    ],
      [
      "When is this fear the strongest?",
      "What picture comes up about old age?",
      "What do I feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear is an experience, not a prophecy."
    ],
      [
      "Fear is an experience, not a prophecy."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I see the fear\".",
      "one breath + \"I see the fear\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the moment the fear begins.",
      "I only notice."
    ],
      [
      "Today I notice the moment the fear begins.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit with myself for a moment.",
      "One breath."
    ],
      [
      "I sit with myself for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens right before it rises?",
      "At what time of day does it appear?",
      "What do I fear will happen in the future?"
    ],
      [
      "What happens right before it rises?",
      "At what time of day does it appear?",
      "What do I fear will happen in the future?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment I have a little space."
    ],
      [
      "In the first moment I have a little space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when it starts.",
      "one breath when it starts."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Body Signals",
    opening: localizedGenderNode(
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ],
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does the tension sit in my body?",
      "What is my body protecting?",
      "What could soften a little?"
    ],
      [
      "Where does the tension sit in my body?",
      "What is my body protecting?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to protect me."
    ],
      [
      "My body is trying to protect me."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Story vs. Fact",
    opening: localizedGenderNode(
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ],
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not me."
    ],
      [
      "A story is not me."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is a story rising\".",
      "an inner sentence - \"This is a story rising\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The Lonely Picture",
    opening: localizedGenderNode(
      [
      "Today I look at the picture that appears.",
      "Not to push it away."
    ],
      [
      "Today I look at the picture that appears.",
      "Not to push it away."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my feet.",
      "One breath."
    ],
      [
      "I feel my feet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What image of loneliness comes up?",
      "What is the most painful part of that picture?",
      "What is the most human part of it?"
    ],
      [
      "What image of loneliness comes up?",
      "What is the most painful part of that picture?",
      "What is the most human part of it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can look without getting pulled in."
    ],
      [
      "I can look without getting pulled in."
    ]
    ),
    action: localizedGenderNode(
      "say to myself \"I am here with me\" once.",
      "say to myself \"I am here with me\" once."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Voices From Outside",
    opening: localizedGenderNode(
      [
      "Today I notice the voices that make the fear louder.",
      "I do not argue with them."
    ],
      [
      "Today I notice the voices that make the fear louder.",
      "I do not argue with them."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my shoulders a little.",
      "One breath."
    ],
      [
      "I soften my shoulders a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What thought or sentence repeats in me?",
      "Whose voice is that?",
      "What does my quiet inner voice say?"
    ],
      [
      "What thought or sentence repeats in me?",
      "Whose voice is that?",
      "What does my quiet inner voice say?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can choose which voice to hold."
    ],
      [
      "I can choose which voice to hold."
    ]
    ),
    action: localizedGenderNode(
      "choose one soft inner sentence.",
      "choose one soft inner sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "The Need for Safety",
    opening: localizedGenderNode(
      [
      "Today I touch the need under the fear.",
      "I do not solve."
    ],
      [
      "Today I touch the need under the fear.",
      "I do not solve."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I place a hand on my chest.",
      "One breath."
    ],
      [
      "I place a hand on my chest.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel safer?",
      "What in me asks for warmth or closeness?",
      "How does it feel when I give myself a moment?"
    ],
      [
      "What do I need to feel safer?",
      "What in me asks for warmth or closeness?",
      "How does it feel when I give myself a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Behind fear there is a request."
    ],
      [
      "Behind fear there is a request."
    ]
    ),
    action: localizedGenderNode(
      "write one short request to myself.",
      "write one short request to myself."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "A Small Connection Now",
    opening: localizedGenderNode(
      [
      "Today I look for a small connection inside me.",
      "Not big, just possible."
    ],
      [
      "Today I look for a small connection inside me.",
      "Not big, just possible."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my back against the chair.",
      "One breath."
    ],
      [
      "I feel my back against the chair.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What could give me a sense of connection now?",
      "What word calms me?",
      "What can I give myself for a moment?"
    ],
      [
      "What could give me a sense of connection now?",
      "What word calms me?",
      "What can I give myself for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small connection is still connection."
    ],
      [
      "A small connection is still connection."
    ]
    ),
    action: localizedGenderNode(
      "one quiet word in my heart.",
      "one quiet word in my heart."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "Compassion for Myself",
    opening: localizedGenderNode(
      [
      "Today I speak to myself gently.",
      "Not like a judge."
    ],
      [
      "Today I speak to myself gently.",
      "Not like a judge."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my jaw.",
      "One breath."
    ],
      [
      "I soften my jaw.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What can I forgive myself for?"
    ],
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What can I forgive myself for?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Gentleness does not cancel the fear."
    ],
      [
      "Gentleness does not cancel the fear."
    ]
    ),
    action: localizedGenderNode(
      "one soft sentence to myself.",
      "one soft sentence to myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "An Inner Request",
    opening: localizedGenderNode(
      [
      "Today I give myself one clear request.",
      "Not a demand, just a request."
    ],
      [
      "Today I give myself one clear request.",
      "Not a demand, just a request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my belly soften a little.",
      "One breath."
    ],
      [
      "I feel my belly soften a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ],
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can calm me."
    ],
      [
      "One request can calm me."
    ]
    ),
    action: localizedGenderNode(
      "write the request in a short sentence.",
      "write the request in a short sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "Value Over Fear",
    opening: localizedGenderNode(
      [
      "Today I remind myself what matters to me.",
      "Not to cancel the fear."
    ],
      [
      "Today I remind myself what matters to me.",
      "Not to cancel the fear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice a calmer face.",
      "One breath."
    ],
      [
      "I notice a calmer face.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What value matters to me in this fear?",
      "How does that value look in a normal day?",
      "What small inner step honors it?"
    ],
      [
      "What value matters to me in this fear?",
      "How does that value look in a normal day?",
      "What small inner step honors it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A value gives me direction."
    ],
      [
      "A value gives me direction."
    ]
    ),
    action: localizedGenderNode(
      "choose one value and repeat it in my heart.",
      "choose one value and repeat it in my heart."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "How I Am With Myself",
    opening: localizedGenderNode(
      [
      "Today I check how I treat myself.",
      "I do not judge."
    ],
      [
      "Today I check how I treat myself.",
      "I do not judge."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I give myself half a minute of quiet.",
      "One breath."
    ],
      [
      "I give myself half a minute of quiet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I pressure myself?",
      "Where can I soften a little?",
      "How do I want to speak to myself in the future?"
    ],
      [
      "When do I pressure myself?",
      "Where can I soften a little?",
      "How do I want to speak to myself in the future?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "How I am with me matters."
    ],
      [
      "How I am with me matters."
    ]
    ),
    action: localizedGenderNode(
      "one sentence of respect to myself.",
      "one sentence of respect to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "A Small Change",
    opening: localizedGenderNode(
      [
      "Today I choose a small change I can hold.",
      "Not a revolution."
    ],
      [
      "Today I choose a small change I can hold.",
      "Not a revolution."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my body steady for a moment.",
      "One breath."
    ],
      [
      "I feel my body steady for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small change could help me today?",
      "How would it look in practice?",
      "What am I willing to try once?"
    ],
      [
      "What small change could help me today?",
      "How would it look in practice?",
      "What am I willing to try once?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small enough is enough."
    ],
      [
      "Small enough is enough."
    ]
    ),
    action: localizedGenderNode(
      "one small step for myself.",
      "one small step for myself."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I close gently.",
      "I choose a sentence that brings me back."
    ],
      [
      "Today I close gently.",
      "I choose a sentence that brings me back."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel air coming in and out.",
      "One breath."
    ],
      [
      "I feel air coming in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this fear?",
      "What is the earliest sign it is rising?",
      "What sentence brings me back to the moment before?"
    ],
      [
      "What did I learn about this fear?",
      "What is the earliest sign it is rising?",
      "What sentence brings me back to the moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I choose presence before reaction."
    ],
      [
      "I choose presence before reaction."
    ]
    ),
    action: localizedGenderNode(
      "one breath and my return sentence.",
      "one breath and my return sentence."
    ),
  },
].map(buildNormalizedDay);

export const fearOfBeingAloneInOldAgeBlueprintEn = buildNormalizedPilotBlueprint({
  id: "fear_of_being_alone_in_old_age_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "fear_of_being_alone_in_old_age",
  category: "anxiety",
  journeyName: {
    he: "פחד להישאר לבד בזקנה",
    en: "Fear of being alone in old age",
    es: "Miedo a quedarse solo/a en la vejez",
  },
  days,
});

export default fearOfBeingAloneInOldAgeBlueprintEn;
